export interface Product {
  id: number;
  name: string;
  nameInfo: string;
  distributor: string;
  image?: string;
  price: number;
  showPrice: boolean;
  divisionId?: number;
  category?: string;
  subcategory?: string;
  pack?: string;
  packOptions?: string[];
  application?: string;
  dosePerHa?: string;
  composition?: string;
  form?: string;
  description?: string;
  pdfLink?: string;
  isEnabled?: boolean;
  externalShop?: string;
  origin: ProductOriginType | null;
  brand?: ProductBrand;
  division?: ProductDivision;
  type: ProductType;
  isExternal: boolean;
  dealersIds?: number[];
  brandId?: number;
  categoryId?: number;
  subcategoryId?: number;
}

export interface ProductBrand {
  id: number;
  name: string;
  synonym: string;
}

export interface ProductDivision {
  id: number;
  name: string;
  synonym: string;
  image?: string;
  isEnabled: boolean;
  isExcluded: boolean;
  noTraceability: boolean;
  position: number;
}

export interface ProductType {
  id: number;
  name: string;
  synonym: string;
}

export enum ProductOriginType {
  DIRECT = 'DIRECT',
  RETAILER = 'RETAILER',
  INVOICE = 'INVOICE',
  ORDER = 'ORDER',
}
